import React, { createContext, useContext, useMemo, useState } from "react";

const AuthCtx = createContext(null);

function getStored(key, fallback) {
  try {
    const stored = localStorage.getItem(key);
    return stored !== null ? stored : fallback;
  } catch {
    return fallback;
  }
}

export function AuthProvider({ children }) {
  const [role, setRoleState] = useState(() => getStored("devRole", "BROKER"));
  const [adminEmail, setAdminEmailState] = useState(() => getStored("adminEmail", "admin@roadoptix.com"));
  const [carrierEmail, setCarrierEmailState] = useState(() => getStored("carrierEmail", "dispatch@bestcarrier.com"));
  const [carrierCompanyId, setCarrierCompanyId] = useState("cmk1paki00003dgs62xa81w2d");
  const [shipperEmail, setShipperEmailState] = useState(() => getStored("shipperEmail", "shipping@globalmfg.com"));
  const [isAuthenticated, setIsAuthenticated] = useState(() => getStored("isAuthenticated", "false") === "true");

  const setRole = (val) => {
    setRoleState(val);
    localStorage.setItem("devRole", val);
  };
  
  const setAdminEmail = (val) => {
    setAdminEmailState(val);
    localStorage.setItem("adminEmail", val);
  };
  
  const setCarrierEmail = (val) => {
    setCarrierEmailState(val);
    localStorage.setItem("carrierEmail", val);
  };
  
  const setShipperEmail = (val) => {
    setShipperEmailState(val);
    localStorage.setItem("shipperEmail", val);
  };

  const setIsAuthenticatedPersist = (val) => {
    setIsAuthenticated(val);
    localStorage.setItem("isAuthenticated", val ? "true" : "false");
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("devRole");
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("carrierEmail");
    localStorage.removeItem("shipperEmail");
    setIsAuthenticated(false);
    setRoleState("BROKER");
    setAdminEmailState("");
    setCarrierEmailState("");
    setShipperEmailState("");
    window.location.href = "/login";
  };

  const value = useMemo(
    () => ({
      role,
      setRole,
      adminEmail,
      setAdminEmail,
      carrierEmail,
      setCarrierEmail,
      carrierCompanyId,
      setCarrierCompanyId,
      shipperEmail,
      setShipperEmail,
      isAuthenticated,
      setIsAuthenticated: setIsAuthenticatedPersist,
      logout,
    }),
    [role, adminEmail, carrierEmail, carrierCompanyId, shipperEmail, isAuthenticated]
  );
  
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  const v = useContext(AuthCtx);
  if (!v) throw new Error("useAuth must be used inside <AuthProvider>");
  return v;
}
